import * as React from 'react';
import {Breadcrumbs, Button, Link, Typography, Grid, Box} from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import StarBorderIcon from "@mui/icons-material/StarBorder";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ChatIcon from '@mui/icons-material/Chat';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {styled} from "@mui/material/styles";
import {useNavigate} from "react-router-dom";
import {secured as axios} from '../../axios';
import { useState, useEffect } from "react";
import StarIcon from "@mui/icons-material/Star";
import {
    Apartment as ApartmentIcon,
    Article as ArticleIcon,
    Celebration as CelebrationIcon, FavoriteBorder, Group as GroupIcon, Highlight as HighlightIcon,
    List as ListIcon,
    QueryStats as QueryStatsIcon, Soap as SoapIcon
} from "@mui/icons-material";
import {Tabs} from '@mui/base/Tabs';
import {TabsList} from '@mui/base/TabsList';
import {TabPanel} from '@mui/base/TabPanel';
import ActualityList from "../actuality/ActualityList";
import Event from "../event/Event";
import  {Tab, tabClasses} from "@mui/base/Tab";
import {buttonClasses} from "@mui/base/Button";
import ExpandlessPlacehoder from "../placeholder/ExpandlessPlacehoder";
import SeeAll from "../actuality/SeeAll";
import {Community} from "./queries/community"
import {INFO,ACTUALITY,EVENT} from "./constant";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import Calendar from "../calendar/Calendar";
import Service from "../service/Service";
import EstablishmentList from "../establishment/EstablishmentList";
import ServiceListBycommunity from "../service/ServiceListByCommunity";
import EstablishmentListByCommunity from "../establishment/EstablishementListByCommunity";
import AlertDialog from "../dashboard/AlertDialog";
import LogoutIcon from "@mui/icons-material/Logout";
import {useLocation} from "react-router-dom";

const TabBase = styled(Tab)`
            background: linear-gradient(88.65deg, #3E9FDD 0%, #2F749F 98.83%) !important;
            border-radius: 5px;
            width: 175px;
            height: 48px !important;
            border: none !important;
            color: #FFFFFF;
            font-family: Roboto;
            font-weight: 550;
            font-size: 1.1rem;
        
            &:focus {
            color: black;
            outline: 1px solid #3E9FDD;
            }
            
            &.${tabClasses.selected} {
            background: white !important;
            color: black;
            outline: 1px solid #3E9FDD;
            }
            
            &.${buttonClasses.disabled} {
            opacity: 0.5;
            cursor: not-allowed;
            color: black;
            background: grey !important;
            }
            `


const Img = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    width: {xs : '364px', md : '364px', lg :'426px'},
    height: '280px',
    borderRadius: '5px',
    backgroundSize : 'cover'
});


const CommunityHeader = ({token, id, setShowNav}) => {
    console.log('token', token)
    const navigate = useNavigate();
    const [communityInfo, setCommunityInfo] = useState([]);
    const [isFavorite, setIsFavorite] = useState("");
    const header = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    const [open, setOpen] = React.useState(false);
    const [disableSeeAll, setDisableSeeAll] = useState(true);
    const [disableActuality, setDisableActuality] = useState(true);
    const [disableEvent, setDisableEvent] = useState(false);
    const [disableSurvey, setDisableSurvey] = useState(true);
    const [disableChat, setDisableChat] = useState(false);
    const [disableDocument, setDisableDocument] = useState(true);
    const [tabValue, setTabValue] = useState(1);
    const [actualities, setActualities] = useState([]);
    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const {mode} = useDarkMode();
    const [eventToSee, setEventToSee] = useState(undefined);
    const [screenNumberDefault, setScreenNumberDefault] = useState(1);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        setIsLoading(true)
        Promise.all([Community.getCommunityInfo(id), Community.getCommunityEvent(id), Community.getCommunityActuality(id)]).then( response => {
            response.map((item) => {
                console.log('tabbbb', tab);
                if (tab === 'event' && Object.keys(item) == EVENT) {
                    setTabValue(5);
                } else if (tab === 'actuality' && Object.keys(item) == ACTUALITY) {
                    setTabValue(2);
                }
                if (Object.keys(item) == INFO) {
                    setCommunityInfo(Object.values(item));
                    console.log(Object.values(item));
                    setIsFavorite(Object.values(item)[0].isFavorite)
                    setDisableSeeAll(false);
                } else if (Object.keys(item) == ACTUALITY) {
                    setActualities(Object.values(item)[0]);
                    setDisableActuality(false);
                } else if (Object.keys(item) == EVENT) {
                    setEvents(Object.values(item)[0]);
                }
            })
            setIsLoading(false)
        } ).catch(() => setIsLoading(false))
    },[])


    const addToFavorite = (id) => {

        axios.post(`${axios.defaults.apiURL}/${communityInfo[0].identifier}/${id}/favorite` )
            .then(function (response) {
                if (response.status === 201) {
                    setIsFavorite(true)
                }
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.clear();
                        navigate('/login');
                    }
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
            });
    }


    const removeFromFavorite = (id) => {
        axios.delete(`${axios.defaults.apiURL}/${communityInfo[0].identifier}/${id}/favorite` )
            .then(function (response) {
                if (response.status === 204) {
                    setIsFavorite(false)
                }
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.clear();
                        navigate('/login');
                    }
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
            });
    }

    const leaveCommunity = (id) => {
        axios.post(`${axios.defaults.apiURL}/leave-community/${id}` )
            .then(function (response) {
                if (response.status === 204) {
                    navigate('/communities');
                }
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.clear();
                        navigate('/login');
                    }
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
            });
    }

    const renderCommunityInfo = (communityInfo) => {
        if (communityInfo.length > 0) {
            const community = communityInfo[0];
            return (
                <div>
                    <Breadcrumbs separator="›" aria-label="navigation" style={{color : mode.settings.textColor3, paddingTop : 15}}>
                        {[
                            <Typography
                                className={'breadcrumbs'}
                                variant={'body2'}
                                onClick={() => navigate('/')}
                                style={{color : mode.settings.breadcrumbColor1}}
                            >
                                Accueil
                            </Typography>,
                            <Typography
                                className={'breadcrumbs'}
                                variant={'body2'}
                                onClick={() => navigate('/communities')}
                                style={{color : mode.settings.breadcrumbColor1}}
                            >
                                Communautés
                            </Typography>,
                            <Typography variant={'body2'} style={{color : mode.settings.textColor3}}>
                                {community.name.text}
                            </Typography>,
                        ]}
                    </Breadcrumbs>
                    <AlertDialog
                        handleAccept={() => leaveCommunity(community.id)}
                        handleClose={handleClose}
                        text={'Voulez-vous vraiment quitter cette communauté ?'}
                        open={open}
                        isLoading={isLoading}></AlertDialog>
                    <Grid container>
                        <Grid xs={12} lg={7.5} md={12} item>
                            <Typography component={'div'} id={'communityDetail'}>
                                <Typography variant={'h2'}>{community.name.text}</Typography>
                                <Typography component={'div'} variant={'h4'} id={'communityStat'}>
                                    <LockIcon style={{marginRight :9}}></LockIcon>
                                    <span style={{marginRight :41}}>{community.public_access.bool ? 'Publique' : 'Privée'}</span>
                                    <PeopleAltIcon role="img" aria-label={"Nombre de men=mbre de la communauté"}></PeopleAltIcon>
                                    <span style={{marginRight :9}}>
                                        {community.membersCount} Membre{community.membersCount > 1 ? 's' : ''}
                                    </span>
                                    {
                                        isFavorite === "" ? <div></div> :
                                        isFavorite
                                            ?
                                            <Button
                                                className = "buttonFavorites"
                                                startIcon={<StarIcon role="img" aria-label={"Enlever des favoris"}/>}
                                                onClick={() => removeFromFavorite(community.id)}
                                                id={'communityHeaderFavorite'}
                                                sx={{width : {xs : '100%', md : '31%', lg : '31%'}}}
                                            >
                                                <Typography variant={'subtitle3'}>Enlever des favoris</Typography>
                                            </Button>
                                            :
                                            <Button
                                                className = "buttonFavorites"
                                                startIcon={<StarBorderIcon role="img" aria-label={"Mettre en favoris"}/>}
                                                id={'communityHeaderFavorite'}
                                                onClick={() => addToFavorite(community.id)}
                                                sx={{width : {xs : '100%', md : '30%', lg : '30%'}}}
                                            >
                                                <Typography variant={'subtitle3'}>Mettre en favoris</Typography>
                                            </Button>
                                    }
                                </Typography>
                            </Typography>

                            <Typography component={'div'} variant={'subtitle1'} id={'communityHeaderSearchContainer'}>
                                <Button
                                    className = "buttonLeave"
                                    startIcon={<LogoutIcon role="img" aria-label={"Quitter la communauté"}/>}
                                    onClick={() => setOpen(true)}
                                >
                                    <Typography variant={'subtitle3'}>Quitter la communauté</Typography>

                                </Button>
                            </Typography>
                        </Grid>
                        <Grid xs lg={3.5} md item>
                            <Box
                                sx={{
                                    width: {xs : '100%', md : '368px', lg :'426px'},
                                    height: '280px',
                                    backgroundImage: `url(${axios.defaults.apiBaseURL}/${community.photo.uri}) , url(${process.env.REACT_APP_DEV_HOST}/assets/img/service0.jpg)`,
                                    backgroundSize : 'cover',
                                    backgroundPosition : 'center'
                                }}
                            >.</Box>
                        </Grid>
                        <br/>
                        <Tabs value={tabValue} defaultValue={1}
                              onChange={(event, newValue) => {
                                  setTabValue(newValue);
                                  if (newValue === 5) {
                                        setScreenNumberDefault(1);
                                  }
                              }}
                              style={{width:"inherit", marginTop:"25px"}}
                        >
                                <TabsList style={{display:"flex", flexWrap:"wrap", justifyContent:"space-between", gap:10}}>
                                    <TabBase value={1} disabled={disableSeeAll}  componentsProps={{ root: { className: 'buttonCommunityNav' } }}
                                        on ={() => setTabValue(1)}
                                    >
                                        <div className={'anchorButtonCommunity'} style={{alignItems:""}}>
                                            &nbsp;<Typography variant={'subtitle3'} >Agenda</Typography><RemoveRedEyeIcon role="img" aria-label="Voir tout les résulats" sx={{marginRight : '10px'}}/>
                                        </div>
                                    </TabBase>
                                    <TabBase value={2} disabled={disableActuality}  componentsProps={{ root: { className: 'buttonCommunityNav' } }}
                                             onClick={() => setTabValue(2)}
                                    >
                                        <div className={'anchorButtonCommunity'} style={{alignItems:""}}>
                                            &nbsp;<Typography variant={'subtitle3'}>Actualités</Typography><ArticleIcon role="img" aria-label="Voir les résultats de catégorie actulalité" sx={{marginRight : '10px'}}/>
                                        </div>
                                    </TabBase>
                                    <TabBase value={3} disabled={disableChat}  componentsProps={{ root: { className: 'buttonCommunityNav' } }}
                                             onClick={() => setTabValue(3)}
                                    >
                                        <div className={'anchorButtonCommunity'} style={{alignItems:""}}>
                                            &nbsp;<Typography variant={'subtitle3'}>Services</Typography><ChatIcon role="img" aria-label="Voir les résultats de catégorie message" sx={{marginRight : '10px'}}/>
                                        </div>
                                    </TabBase>
                                    <TabBase value={4} disabled={disableSurvey} componentsProps={{ root: { className: 'buttonCommunityNav' } }}
                                             onClick={() => setTabValue(4)}
                                    >
                                        <div className={'anchorButtonCommunity'}>
                                            &nbsp;<Typography variant={'subtitle3'}>Sondages</Typography><QueryStatsIcon role="img" aria-label="Voir les résultats de catégorie sondage" sx={{marginRight : '10px'}}/>
                                        </div>
                                    </TabBase>
                                    <TabBase value={5} disabled={disableEvent}  componentsProps={{ root: { className: 'buttonCommunityNav' } }}
                                             onClick={() => { setTabValue(5); }}
                                    >
                                        <div className={'anchorButtonCommunity'}>
                                            &nbsp;<Typography variant={'subtitle3'}>Evènements</Typography><CelebrationIcon role="img" aria-label="Voir les résultats de catégorie évenement" sx={{marginRight : '10px'}}/>
                                        </div>
                                    </TabBase>
                                    <TabBase value={6} disabled={disableDocument}  componentsProps={{ root: { className: 'buttonCommunityNav' } }}
                                             onClick={() => setTabValue(6)}
                                    >
                                        <div className={'anchorButtonCommunity'}>
                                            &nbsp;<Typography variant={'subtitle3'}>Documents</Typography><DocumentScannerIcon role="img" aria-label="Voir les résultats de catégorie document" sx={{marginRight : '10px'}}/>
                                        </div>
                                    </TabBase>
                                </TabsList>
                            <br/>
                            <TabPanel value={1}>
                                <Calendar events={events} setTabValue={setTabValue} setEventToSee={setEventToSee}
                                          setScreenNumberDefault={setScreenNumberDefault} >

                                </Calendar>
                            </TabPanel>
                            <TabPanel value={2}>
                                <ActualityList token={token} id={id} actualitiesResult={actualities}>
                                </ActualityList>
                            </TabPanel>
                            <TabPanel value={3}>
                                <ServiceListBycommunity communityId={id}></ServiceListBycommunity>
                                {/*<EstablishmentList/>*/}
                                <EstablishmentListByCommunity communityId={id}></EstablishmentListByCommunity>
                            </TabPanel>
                            <TabPanel value={4}>
                                <div>Sondage</div>
                            </TabPanel>
                            <TabPanel value={5}>
                                <Event setDisableEvent={setDisableEvent} eventsList={events} screenNumberDefault={screenNumberDefault} eventToSee={eventToSee}></Event>
                            </TabPanel>
                            <TabPanel value={6}>
                                <div>Document</div>
                            </TabPanel>
                        </Tabs>
                    </Grid>
                </div>
            )
        }
    }

    return !isLoading ? renderCommunityInfo(communityInfo) : <ExpandlessPlacehoder/>
}

export default CommunityHeader;
